import EmptyWrap from "@/components/Gui/EmptyWrap";

export default [
    {
        path: 'faq',
        component: EmptyWrap,
        children: [
            {
                path: '',
                name: 'faq.list',
                component: require('@/views/Faq/FaqList').default,
            },
            {
                path: 'create',
                name: 'faq.create',
                component: require('@/views/Faq/FaqForm').default,
            },
            {
                path: ':id',
                component: require('@/views/Faq/Card/WrapBlock').default,
                children: [
                    {
                        path: 'detail',
                        name: 'faq.detail',
                        component: require('@/views/Faq/Card/FaqDetail').default,
                    },
                ]
            },
            {
                path: ':id/edit',
                name: 'faq.edit',
                component: require('@/views/Faq/FaqForm').default,
            },
        ]
    },
]